import { combineReducers } from 'redux'
import form from './form'

const pickupPeopleReducer = combineReducers({
  form
})

export default pickupPeopleReducer
